export const extractBasicData = (apiData: any) => {
  const id = apiData.id?.toString() || `temp_${Date.now()}`;
  const numero = apiData.numero?.toString() || id;
  const contato = apiData.cliente?.contato || apiData.contato || '';
  return { id, numero, contato };
};

export const extractClientData = (apiData: any) => {
  let cliente = '';

  if (apiData.empresa && typeof apiData.empresa === 'object' && apiData.empresa.nome) {
    cliente = apiData.empresa.nome;
  } else if (apiData.cliente && typeof apiData.cliente === 'object' && apiData.cliente.nome) {
    cliente = apiData.cliente.nome;
  } else if (typeof apiData.empresa === 'string') {
    cliente = apiData.empresa;
  } else if (typeof apiData.cliente === 'string') {
    cliente = apiData.cliente;
  } else if (apiData.empresa_nome) {
    cliente = apiData.empresa_nome;
  } else if (apiData.cliente_nome) {
    cliente = apiData.cliente_nome;
  } else {
    cliente = 'Cliente não informado';
  }

  return { cliente };
};

export const extractOperatorData = (apiData: any) => {
  let operador = '';

  if (apiData.operador && typeof apiData.operador === 'object' && apiData.operador.nome) {
    operador = apiData.operador.nome;
  } else if (typeof apiData.operador === 'string') {
    operador = apiData.operador;
  } else if (apiData.operador_nome) {
    operador = apiData.operador_nome;
  }

  return operador;
};

export const extractProjectData = (apiData: any) => {
  let produto = '';

  if (apiData.produto && typeof apiData.produto === 'object' && apiData.produto.nome) {
    produto = apiData.produto.nome.trim();
  } else if (apiData.produto && typeof apiData.produto === 'string') {
    produto = apiData.produto.trim();
  } else {
    produto = 'Produto não informado';
  }

  const projeto = apiData.projeto?.nome || 'Projeto não informado';

  let projetoFechado = false;
  if (apiData.projeto && typeof apiData.projeto === 'object' && apiData.projeto.fechado !== undefined) {
    projetoFechado = Boolean(apiData.projeto.fechado);
  } else if (apiData.projeto_fechado !== undefined) {
    projetoFechado = Boolean(apiData.projeto_fechado);
  }

  return { produto, projeto, projetoFechado };
};

export const extractStatusData = (apiData: any) => {
  const statusDescricao = apiData.status_descricao || apiData.status?.descricao || apiData.status || 'aberta';
  const status = statusDescricao.toLowerCase();

  let natureza = 'Suporte';
  if (apiData.natureza_descricao) {
    natureza = apiData.natureza_descricao;
  } else if (apiData.natureza?.descricao) {
    natureza = apiData.natureza.descricao;
  } else if (apiData.natureza?.nome) {
    natureza = apiData.natureza.nome;
  } else if (apiData.natureza && typeof apiData.natureza === 'string') {
    natureza = apiData.natureza;
  }

  const naturezasValidas = ['Suporte', 'Desenvolvimento', 'Consultoria', 'Implantação', 'Treinamento'];
  if (!naturezasValidas.includes(natureza)) {
    natureza = 'Suporte';
  }

  return { status, natureza };
};

export const extractDateData = (apiData: any) => {
  let dataAbertura = apiData.data_real || apiData.data?.real || apiData.dataAbertura || apiData.incluido || apiData.created_at || '';

  if (dataAbertura && typeof dataAbertura === 'string') {
    if (dataAbertura.match(/^\d{4}-\d{2}-\d{2}$/)) {
      // already ISO
    } else if (dataAbertura.includes('/')) {
      const [dia, mes, ano] = dataAbertura.split('/');
      if (dia && mes && ano) {
        dataAbertura = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
      }
    } else if (dataAbertura.includes(' ')) {
      dataAbertura = dataAbertura.split(' ')[0];
    } else if (dataAbertura.includes('T')) {
      dataAbertura = dataAbertura.split('T')[0];
    }
  }

  const dataFechamento = apiData.data?.fechamento || apiData.dataFechamento || undefined;
  return { dataAbertura, dataFechamento };
};

export const extractAdditionalData = (apiData: any) => {
  const observacoes = apiData.chamado_descricao || apiData.chamado?.descricao || apiData.observacoes || '';

  let tipoProjeto = 'Não';
  if (apiData.projeto && typeof apiData.projeto === 'object' && apiData.projeto.fechado !== undefined) {
    tipoProjeto = apiData.projeto.fechado ? 'Sim' : 'Não';
  } else if (apiData.projeto_fechado !== undefined) {
    tipoProjeto = apiData.projeto_fechado ? 'Sim' : 'Não';
  }

  let tipoChamado = '';
  if (apiData.tipoChamado && typeof apiData.tipoChamado === 'object' && apiData.tipoChamado.id) {
    tipoChamado = apiData.tipoChamado.id;
  } else if (apiData.tipo_chamado && typeof apiData.tipo_chamado === 'string') {
    tipoChamado = apiData.tipo_chamado.trim();
  } else if (apiData.natureza && typeof apiData.natureza === 'object' && apiData.natureza.id) {
    tipoChamado = apiData.natureza.id;
  } else if (apiData.natureza && typeof apiData.natureza === 'object' && apiData.natureza.descricao) {
    const descricao = apiData.natureza.descricao.toLowerCase();
    if (descricao.includes('suporte')) tipoChamado = 'suporte';
    else if (descricao.includes('suporte orçado') || descricao.includes('suporteorcado')) tipoChamado = 'suporteorcado';
    else if (descricao.includes('atividade projeto') || descricao.includes('atividadeprojeto')) tipoChamado = 'atividadeprojeto';
    else if (descricao.includes('orcamento')) tipoChamado = 'orcamento';
    else tipoChamado = 'suporte';
  } else if (apiData.natureza && typeof apiData.natureza === 'string') {
    const natureza = apiData.natureza.trim().toLowerCase();
    if (natureza.includes('suporte orçado') || natureza.includes('suporteorcado')) tipoChamado = 'suporteorcado';
    else if (natureza.includes('atividade projeto') || natureza.includes('atividadeprojeto')) tipoChamado = 'atividadeprojeto';
    else if (natureza.includes('orcamento')) tipoChamado = 'orcamento';
    else tipoChamado = 'suporte';
  } else {
    tipoChamado = 'suporte';
  }

  const incluidoPor = apiData.operador_nome || apiData.operador?.nome || apiData.incluidoPor || '';
  const estatisticasChamado = apiData.chamado || apiData.estatisticas;
  const contato = apiData.contato || '';

  return { observacoes, tipoProjeto, tipoChamado, incluidoPor, estatisticasChamado, contato };
};
